import appStore                 from "@/stores/appStore";
import { notificationsSidebar } from '@stonecode/notifications-sidebar';
import cacheSystem              from "@widesk-core/models/apiCacheSystem";
import authStore                from "@widesk-core/stores/authStore";
import listFilterManagerStore   from '@widesk-ui/stores/ListFilterManagerStore';
import mercureEventsStore       from '@/stores/mercureEventsStore';
import userMercureListener      from '@/services/userMercureListener';

export const onLogout = async () => {
	try {
		notificationsSidebar.clearPlugin();
	} catch (err) {
		// Le plugin de notifications peut ne pas avoir fini de s'initialiser (ex. déconnexion
		// depuis l'écran de chargement) : on ne bloque pas la déconnexion pour autant.
		console.warn('notificationsSidebar.clearPlugin() a échoué :', err);
	}

	userMercureListener.stop();
	mercureEventsStore.clear();
	cacheSystem.clear();
	listFilterManagerStore.clear();
	appStore.clear();
};

export default async () => {
	await onLogout();
	authStore.clear();
};